import cn from "clsx";
import IntlPopover from "./popover";
import styles from "../reviews.module.scss";
import styles2 from "../reviewDetail.module.scss";
import LoadingIcon from "@/components/loadingIcon";

import { Typography } from "@mui/material";
import { MouseEvent, useState } from "react";
import { anonymousData } from "@/app/csr-src/apis/profile/review.interface";
import UKDialog from "@/components/UKDialog";
import UKToast from "@/components/UKToast/index";
import { handleDeleteComment } from "@/app/csr-src/apis/profile/review.api";
import {
  Button,
  DialogContent,
  DialogContentText,
  DialogActions,
  DialogTitle,
} from "@mui/material";
import { sendClickTrack as myReviewSendClickTrack } from "@/tracks/25155";
import { useTranslation } from "@/i18n/client";

const typographyStyle = {
  fontSize: "14px",
  lineHeight: "20px",
  padding: "5px 12px",
  margin:"4px",
  cursor: "pointer",
  minWidth: "148px",
  whiteSpce: "nowrap",
};

interface Props {
  anonymous: boolean;
  params?: any;
  pageType?: string;
  expConfig?: any;
  onRefresh?: () => void;
  onDeleteCallback?: () => void;
  onAnonymous?: (is: boolean, data: anonymousData) => void;
}
export default function MenuOpts({
  anonymous,
  params,
  pageType,
  expConfig,
  onRefresh,
  onAnonymous,
  onDeleteCallback,
}: Props) {

  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<Element | null>(null);
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const { skuId, commentId } = params || {};
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const handleClick = (event: MouseEvent) => {
    /** 点击事件上报-已完成评价tab下按钮点击 */
    switch (pageType) {
      case "reviewComment":
        // {"button_name":"1-helpful，2-comment，3-more","commentId":""}
        myReviewSendClickTrack.My_Reviews_Completed_Btn({ button_name: "3", commentId: `${commentId}` })
        break;

      default:
        break;
    }
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const onConfirmDelete = async () => {
    setIsLoading(true);
    const { skuId, commentId } = params;
    const res: any = await handleDeleteComment({
      skuId,
      commentId,
    });
    if (res && res.success) {
      if (res?.data?.deleteResult) {
        localStorage.setItem('scrollPosition', JSON.stringify(window.scrollY));
        setDialogOpen(false);
        onDeleteCallback?.();
        UKToast.show({
          icon: "success",
          content: t("common.message.deleteSuccessful"),
        });
      } else {
        UKToast.show({
          icon: "error",
          content: t("common.message.deleteFailed"),
        });
      }
      handlePopoverClose();
      onRefresh?.();
      setIsLoading(false);
    } else {
      setIsLoading(false);
      UKToast.show({
        icon: "error",
        content: res.msg || t("common.message.deleteFailed"),
      });
    }
  };

  const onOpenDeleteDialog = () => {
    setDialogOpen(true);
    handlePopoverClose();
  };

  const popoverOpen = Boolean(anchorEl);
  const id = popoverOpen ? "simple-popover" : "";

  return (
    <>
      <div className={cn(styles.btn, styles2.btn)} aria-describedby={id} onClick={handleClick}>
        <i className={cn(styles.moreIcon, styles.mar, styles2.moreIcon, styles2.mar)}></i>
      </div>
      <IntlPopover id={id} open={popoverOpen} anchorEl={anchorEl} onClose={handlePopoverClose}>
        <Typography
          sx={typographyStyle}
          className="report-block"
          exptag={expConfig?.delete?.expTag}
          data-exptag-json-param={JSON.stringify(expConfig?.delete?.data)}
          data-exptag-config={expConfig?.delete?.config}
          onClick={() => {
            /** 点击事件上报-已完成评价tab下按钮点击 */
            switch (pageType) {
              case "reviewComment":
                // {"button_name":"1-helpful，2-comment，3-more","commentId":""}
                myReviewSendClickTrack.My_Reviews_More_Layer({ button_name: "3", commentId: `${commentId}` })
                break;

              default:
                break;
            }
            onOpenDeleteDialog();
          }}>
          {t("common.btnText.delete")}
        </Typography>
      </IntlPopover>

      <UKDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        showCloseBtn={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle />
        <DialogContent>
          <DialogContentText id="alert-dialog-description" sx={{ marginTop: "12px" }}>
            {t("review.deleteConfirm")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} variant="outlined">
            {t("common.btnText.cancel")}
          </Button>
          <Button
            disabled={isLoading}
            startIcon={isLoading ? <LoadingIcon /> : null}
            onClick={onConfirmDelete}
            autoFocus
            variant="contained"
          >
            {t("common.btnText.delete")}
          </Button>
        </DialogActions>
      </UKDialog>
    </>
  );
}
